var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronLeftGreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 23
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#41cd8c",
  d: "m11.44 0 1.577 1.577-9.898 9.897 9.898 9.898-1.576 1.577L0 11.509z"
})));
export default SvgChevronLeftGreen;